/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import type { Mention } from '@/types';

import { validationInformationsMention } from '..';

/**
 * Validation de l'étape 3 « Mentions ».
 *
 * Chaque mention est validée individuellement (numéro, date d'apposition, titre,
 * code ANTS obligatoires) et l'on vérifie qu'aucun numéro n'est utilisé deux fois.
 *
 * Les erreurs sont regroupées par identifiant de mention ; la clé spéciale
 * `numerosDupliques` porte l'erreur d'unicité globale.
 */
const validationStep3 = (mentions: Mention[] = []) => {
  const errors: Record<string, any> = {};

  _.forEach(mentions, (mention) => {
    const mentionErrors = validationInformationsMention(mention);
    if (!_.isEmpty(mentionErrors)) {
      errors[mention.id] = mentionErrors;
    }
  });

  const numeros = _(mentions)
    .map((mention) => _.trim(_.toString(mention.numero)))
    .reject(_.isEmpty)
    .value();
  const numerosDupliques = _(numeros)
    .countBy()
    .pickBy((count) => count > 1)
    .keys()
    .value();

  if (!_.isEmpty(numerosDupliques)) {
    errors.numerosDupliques = `Deux mentions ne peuvent pas avoir le même numéro (${numerosDupliques.join(', ')})`;
  }

  return errors;
};

export default validationStep3;
